export const SET_POINTS = "SET_POINTS";
export const SET_SELECTED_POINTS = "SET_SELECTED_POINTS";
